import {
  Box,
  Button,
  Flex,
  Icon,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Text,
  useDisclosure
} from '@chakra-ui/react'
import { faUserPlus } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { userListContext } from 'BrokerTsLib/src/context'
import type { UserGridItem, UserPagedQuery } from 'BrokerTsLib/src/dtos'
import { useSearchUsers } from 'BrokerTsLib/src/hooks/useUser'
import { useState } from 'react'

import { Pagination } from '../Pagination'
import {
  UserList,
  UserListEmailColumn,
  UserListNameColumn,
  UserListOrganizationColumn,
  UserListRolesColumn,
  UserListTypeColumn,
  UserListValidityColumn,
} from '../users/UserList'
import { UserListFilter } from '../users/UserListFilter'
import { AddButton } from './AddButton'

const pageSize = 15
export const AddFlexGroupUser = ({
  onAddUser,
  alreadyAdded,
}: {
  onAddUser: (userId: string) => Promise<any>
  alreadyAdded: UserGridItem[]
}) => {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const [filter, setFilter] = useState<UserPagedQuery>({
    showInvalid: false,
    pageIndex: 1,
    pageSize,
  })

  const { data, refetch, isLoading } = useSearchUsers(filter, { enabled: isOpen })

  const users = data?.data.items ?? []

  return (
    <Box w='full' mt='auto'>
      <Button
        w='full'
        colorScheme="primary"
        onClick={() => onOpen()}
        whiteSpace="nowrap"
      >
        <Icon as={FontAwesomeIcon} icon={faUserPlus} size='lg' />
        Přidat uživatele
      </Button>
      <Modal size="6xl" isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />

        <ModalContent>
          <ModalHeader>
            <Text>Přidat uživatele</Text>
            <ModalCloseButton />
          </ModalHeader>

          <ModalBody sx={{ pt: 0, pb: 6, gap: 4 }}>
            <userListContext.Provider
              value={{
                loading: isLoading,
                totalCount: data?.data.totalCount ?? 0,
                currentPage: filter.pageIndex,
                pageSize,
                filter,
                setCurrentPage: (p) => setFilter((f) => ({ ...f, pageIndex: p })),
                setPageSize: () => { },
                updateFilter: setFilter,
                reload: () => refetch(),
              }}
            >
              <Flex flexDir={'column'} gap={4}>
                <UserListFilter />
                <UserList
                  users={users}
                  columnsDefinition={[
                    {
                      key: 'addToFlexGroup',
                      name: '',
                      cellExpr: (item) => (
                        <AddButton
                          alreadyAdded={alreadyAdded.some((x) => x.userId === item.userId)}
                          onClick={() => onAddUser(item.userId)} />
                      ),
                      cellProps: { p: 0, px: 2, w: 0 },
                    },
                    UserListNameColumn,
                    UserListOrganizationColumn,
                    UserListEmailColumn,
                    UserListValidityColumn,
                    UserListTypeColumn,
                    UserListRolesColumn,
                  ]}
                />
                <Pagination context={userListContext} />
              </Flex>
            </userListContext.Provider>
          </ModalBody>
        </ModalContent>
      </Modal>
    </Box>
  )
}